import { useLocation, useNavigate } from "react-router-dom";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import Reportes from "../../page/reportes/Reportes";
import { useContext, useEffect, useState } from "react";
import { authContext } from "../../../../context/auth/AuthContext";
import Swal from "sweetalert2";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const ReportesController = () => {
  const location = useLocation();
  const getParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const { user } = useContext(authContext);
  const { data } = user;
  const [filter, setFilter] = useState({
    sort: "-reportes.created_at",
    per_page: 20,
  });
  const [loading, setLoading] = useState(false);
  const [provincias, setProvincias] = useState(null);
  const [estadisticas, setEstadisticas] = useState({
    "total-ventas-mes-anterior": 0,
    "total-ventas": 0,
    "ventas-hoy": 0,
    "eventos-activos": 0,
    "eventos-mas-vendidos": [0],
    "entradas-total": 0,
    "entradas-hoy": 0,
    "reportes-tiempo-real": [],
    "ventas-semana-cantidad": [],
    "ventas-semana-total": [],
  });
  const [reportes, setReportes] = useState(null);
  let controller;

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "link":
        {
          let params = {
            ...filter,
            page: value,
          };

          fetch(setReportes, params, "/reportes");
        }
        break;
      case "prev_page":
        {
          let params = {
            ...filter,
            page: value,
          };

          fetch(setReportes, params, "/reportes");
        }
        break;
      case "next_page":
        {
          let params = {
            ...filter,
            page: value,
          };

          fetch(setReportes, params, "/reportes");
        }
        break;
      case "payway":
        {
          const response = await apiPrivateAntesala.get("/reportes/payway", {
            params: { codigo: value },
          });
          console.log(response);
          return Swal.fire({
            title: "<strong>DATOS DE PAGO</strong>",
            icon: "info",
            html: ``,
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: false,
          });
        }
        break;
      case "estado":
        {
          let formData = new FormData();
          formData.append("_method", "PUT");
          formData.append("status", value.status);
          formData.append("evento_id", value.eventos_id);

          let id = value.codigo;
          if(value.membership){
            id = value.id;
          }

          const response = await RestPrivateAntesala({
            url: `/reportes/${id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.status == 201 || response.status == 200) {
            let params = {
              ...filter,
            };

            fetch(setReportes, params, "/reportes");
            return Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "201",
              type: "success",
            });
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "400",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "download-entrada":
        {
          try {
            const response = await apiPrivateAntesala.get(
              "/reportes/download",
              {
                responseType: "blob",
                params: {
                  precio: value.reporte.unidad,
                  entrada: value.reporte.entrada.nombre,
                  fecha: value.reporte.fecha,
                  evento: value.reporte.evento.nombre,
                  titular: value.reporte.nombre_cliente,
                  sala: value.reporte.evento.nombre_sitio,
                  direccion: `${value.reporte.evento.direccion} ${value.reporte.evento.localidad}, ${value.reporte.evento.provincia}`,
                  codigo: value.codigo,
                },
              }
            );

            // Crear un enlace para descargar la imagen
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "ENTRADA-" + value.codigo + ".png"); // nombre del archivo
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (error) {
            console.error("Error al descargar la imagen:", error);
          }
        }
        break;
      case "añadir-reporte":
        {
          return navigate("/dashboard/reportes/nuevo");
        }
        break;
      case "editar-reporte":
        {
          return navigate("/dashboard/reportes/" + value);
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            ...filter,
            ["filter[search]"]: e.target.value,
          };

          setFilter({ ...params });

          return fetch(setReportes, params, "/reportes", signal);
        }
        break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    let params = {
      ...filter,
    };

    fetch(setReportes, params, "/reportes");
  }, [location]);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  
  useEffect(() => {
    fetch(setEstadisticas, {}, "/reportes/estadisticas");
  }, []);

  return (
    <Reportes
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      data={reportes ?? { data: [], links: [] }}
      setData={setReportes}
      onClick={onClick}
      onChange={onChange}
      provincias={provincias ?? []}
      navigate={navigate}
      user={data}
      estadisticas={estadisticas}
    />
  );
};

export default ReportesController;
